import React, { Component } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'mobx-react';

import './main.css';
import Pages from './pages';

import session from './session';
import { ThemeProvider } from 'styled-components';
import theme from './styledSystem/theme';

class App extends Component {
    render() {
        return (
            <ThemeProvider theme={theme}>
                <Router>
                    <Provider session={session}>
                        <Pages />
                    </Provider>
                </Router>
            </ThemeProvider>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js